import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scroll to the top on every route change (React Router doesn't do this by
 * default, so moving from a long page used to land mid-way down the next
 * one). Hash links (#features) are respected.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        el.scrollIntoView()
        return
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash])

  return null
}
